<template>
  <CRow>
    <CModal
        :title="
        submitType === 'Update'
          ? $lang.currencytype.crud.edit
          : $lang.currencytype.crud.create
      "
        size="lg"
        :show.sync="largeModal"
        :no-close-on-backdrop="true"
        color="primary"
    >
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>{{
          err_msg
        }}
      </CAlert>
      <CForm novalidate @submit.prevent="onSubmit">
        <CCardBody>
          <div
              class="form-group"
              :class="{ 'form-group--error': $v.currencytype.title.$error }"
          >
            <label class="form__label"
            >{{ $lang.currencytype.form.title }}
              <required_span/>
            </label>
            <input
                :placeholder="$lang.currencytype.form.title"
                :maxlength="maxlength.title"
                class="form-control"
                v-model="currencytype.title"
            />
            <small
                class="error"
                v-if="
                $v.currencytype.title.$error && !$v.currencytype.title.required
              "
            >{{ $lang.currencytype.validation.required.title }}</small
            >
            <small
                class="error"
                v-if="
                $v.currencytype.title.$error && !$v.currencytype.title.minLength
              "
            >{{ $lang.currencytype.validation.minLength.title }}
              {{ $v.currencytype.title.$params.minLength.min }}
              {{ $lang.currencytype.validation.common.letter }}</small
            >
          </div>

          <div
              class="form-group"
              :class="{ 'form-group--error': $v.currencytype.symbol.$error }"
          >
            <label class="form__label"
            >{{ $lang.currencytype.form.symbol }}
              <required_span/>
            </label>
            <input
                :maxlength="maxlength.symbol"
                :placeholder="$lang.currencytype.form.symbol"
                class="form-control"
                v-model="currencytype.symbol"
            />
            <small
                class="error"
                v-if="
                $v.currencytype.symbol.$error &&
                !$v.currencytype.symbol.required
              "
            >{{ $lang.currencytype.validation.required.symbol }}</small
            >
            <small
                class="error"
                v-if="
                $v.currencytype.symbol.$error &&
                !$v.currencytype.symbol.minLength
              "
            >{{ $lang.currencytype.validation.minLength.symbol }}
              {{ $v.currencytype.symbol.$params.minLength.min }}
              {{ $lang.currencytype.validation.common.letter }}</small
            >
          </div>

          <div class="form-group" :class="{ 'form-group--error': '' }">
            <label class="form__label">{{ $lang.common.form.isActive }} </label>

            &nbsp;
            <input
                type="checkbox"
                :placeholder="$lang.common.form.isActive"
                :value="1"
                @change="changedIsActive"
                v-model="currencytype.isActive"
            />
          </div>
        </CCardBody>
        <CCardFooter>
          <CButton
              type="submit"
              size="sm"
              color="primary"
              :disabled="submitted"
          >
            <CIcon name="cil-check-circle"/>
            {{ $lang.buttons.general.crud.submit }}
          </CButton>
        </CCardFooter>
      </CForm>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none"
        >Discard
        </CButton
        >
        <CButton
            @click="darkModal = false"
            color="success"
            style="display: none"
        >Accept
        </CButton
        >
      </template>
    </CModal>

    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.currencytype.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButton
                    color="primary"
                    v-on:click="createTableRow"
                    v-if="checkPermission('create-currencyType')"
                    style="margin-right: 10px"
                >
                  {{ $lang.buttons.general.crud.create }}
                </CButton>
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Currency')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <!--        {{ showAlert }}-->
        <!--        <alerts :message="alertMessage" type="success" :v-if="showAlert"/>-->
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/currency-type/list"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'Currency')"
          >
            <template #status="data">
              <CBadge :color="statusBudget(data.row.status)">{{ data.row.status }}</CBadge>
            </template>
            <template #title="data">
              <span :title="data.row.title">{{
                  trimfunction(data.row.title, 20)
                }}</span>
            </template>
            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.edit"
                  v-on:click="editTableRow(data.row.id)"
                  v-if="checkPermission('edit-currencyType')"
              >
                <i class="fas fa-pencil-alt"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('delete-currencyType')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {currencytype} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {minLength, required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "CurrencyType",
  mixins: [Mixin],
  components: {
    required_span,
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      json_data: [],
      json_label: {},
      json_title: "",
      err_msg: "",
      largeModal: false,
      messageColor: "success",
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      module: currencytype,
      currencytype: {
        title: "",
        symbol: "",
      },
      maxlength: {
        title: Maxlength.currencytype.title,
        symbol: Maxlength.currencytype.symbol,
      },
      columns: ["title", "symbol", "status", "actions"],
      data: [],
      options: {
        headings: {
          title: this.$lang.currencytype.table.title,
          status: this.$lang.common.table.isActive,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["title"],
        sortable: ["title"],
        filterable: ["title"],
      },
    };
  },
  validations: {
    currencytype: {
      title: {
        required,
        minLength: minLength(1),
      },
      symbol: {
        required,
        minLength: minLength(1),
      },
    },
  },
  mounted() {
    let self = this;
    // this.loadData();
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.currencytype.isActive = 1;
      } else {
        self.currencytype.isActive = 0;
      }
    },

    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        // <--
        if (result.value) {
          // <-- if accepted
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.data.status === 200) {
                  self.$refs.myTable.refresh();
                  self.messageColor = "success";
                  self.alertMessage = response.data.message;
                  self.dismissCountDownS = 10;
                  // self.$router.go()
                } else {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "danger";
                  self.dismissCountDownS = 10;
                }
              });
        }
      });
    },
    createTableRow() {
      let self = this;
      self.$v.$reset();
      self.submitType = "Create";
      self.currencytype.title = "";
      self.currencytype.symbol = "";
      self.currencytype.isActive = 1;
      self.largeModal = true;
      //this.$router.push({name: 'Country Create'})
    },
    editTableRow(item) {
      let self = this;
      self.$v.$reset();
      self.submitType = "Update";
      let id = item;
      self.editId = item;
      axios
          .get(this.viewUrlApi(this.module, id), self.model)
          .then(function (response) {
            if (response) {
              let responseData = response.data;
              self.currencytype.title = responseData.title;
              self.currencytype.symbol = responseData.symbol;
              self.currencytype.isActive = responseData.isActive;
            } else {
              self.data = [];
            }
          });

      // this.$router.push({path: `country/edit/${(item)}`})
      self.largeModal = true;
    },
    rowClicked(item) {
      this.$router.push({path: `currencytype/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
          });
    },
    onSubmit() {
      let self = this;
      this.$v.currencytype.$touch();
      if (this.$v.currencytype.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";
        if (this.submitType === "Update") {
          setTimeout(() => {
            let self = this;
            const postData = {
              title: self.currencytype.title,
              symbol: self.currencytype.symbol,
              isActive: self.currencytype.isActive,
            };
            axios
                .post(this.updateUrlweb(this.module, self.editId), postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.messageColor = "success";
                    self.submitted = false; //Enable Button
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                    self.submitted = false; //Enable Button
                  }
                })
                .catch(function (error) {
                  self.submitted = false; //Enable Button
                });
          }, 500);
        } else {
          setTimeout(() => {
            let self = this;
            const postData = {
              title: self.currencytype.title,
              symbol: self.currencytype.symbol,
              isActive: self.currencytype.isActive,
            };
            axios
                .post(this.createUrlWeb(this.module), postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.largeModal = false;
                    self.messageColor = "success";
                    self.$refs.myTable.refresh();
                    self.submitted = false; //Enable Button
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                    self.submitted = false; //Enable Button
                  }
                })
                .catch(function () {
                  self.submitted = false; //Enable Button
                });
          }, 500);
        }
      }
    },
  },
};
</script>
